module.exports = __webpack_public_path__ + "waste-ico.webp?7b5e17c01e513439f11b512c815518c3";